import { Link } from 'react-router-dom';

const items = [
  {
    title: 'Fabric and Colors',
    image: '/assets/img/7f1197bd95cb.webp',
    description: 'Premium 3-ply fabric engineered for all weather, available in a wide range of colours.',
    tags: ['3-ply fabric', 'All-weather', 'UV resistant', 'Wide palette'],
    link: '/products/fabric-and-colours',
  },
  {
    title: 'Our Blog',
    image: '/assets/img/b52507216157.webp',
    description: 'Tips, guides, and inspiration for events, festivals, and everything stretch tent related.',
    tags: ['How-to guides', 'Event tips', 'Inspiration', 'Industry news'],
    link: '/blog',
  },
];

export default function ExploreFurther() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <h2 className="text-4xl font-bold text-gray-900 mb-3">
            Explore Further
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Everything you need to know about our stretch tent systems. Click any card to learn more.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {items.map((item, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="relative h-60 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="text-xl font-bold text-white leading-snug">
                    {item.title}
                  </h3>
                </div>
              </div>

              <div className="p-6 flex flex-col gap-4">
                <p className="text-sm text-gray-600 leading-relaxed">
                  {item.description}
                </p>

                <div className="flex flex-wrap gap-1.5">
                  {item.tags.map((tag, idx) => (
                    <span
                      key={idx}
                      className="px-2.5 py-1 bg-teal-50 text-teal-600 text-xs font-medium rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <Link
                  to={item.link}
                  className="inline-flex items-center gap-1.5 text-teal-500 hover:text-teal-600 font-semibold text-sm mt-auto group/btn whitespace-nowrap"
                >
                  <span>Learn More</span>
                  <i className="ri-arrow-right-line text-base group-hover/btn:translate-x-1 transition-transform"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
